import Loadable from 'react-loadable';

import Spinner from '@stubhub/react-spinner';

const searchSuggestionList = Loadable({
  loader: () => import(/* webpackChunkName: "swi-searchSuggestionList" */ './index'),
  loading: Spinner,
});

export default searchSuggestionList;
